module.exports = __webpack_public_path__ + "static/media/entre_em_contato.ccdb1ac5.svg";